import { AxiosError, AxiosResponse } from 'axios';

// project imports
import {
  createDeleteHeaderData,
  createHeaderData,
  createPutHeaderData,
  createQueryParams
} from 'utils/restUtils';
import { apiClient } from 'services/restService';

// types
import { HttpHeaders } from 'models';
import { AppThunk } from 'models/store';
import {
  AddUserRoleRequestBody,
  CreateEmsMemberAccountUserRequestBody
} from '../eaiTypes';
import { Dispatch } from 'react';
import { openSnackbar } from '../../app/appSlice';
import i18n from 'i18next';
import { accountLogout } from 'features/account/accountSlice';
import { logError } from 'services/Logging';

// ==============================|| EMS MEMBER ACCOUNT USER THUNKS ||============================== //

export const setCurrentEmsMemberAccountUser =
  (
    emsMemberAccountId: string | bigint,
    emsMemberAccountUserId: number,
    callback?: () => any
  ): AppThunk =>
  (dispatch: Dispatch<ReturnType<typeof accountLogout>>) => {
    const headers: HttpHeaders = createHeaderData(false, '*/*');

    dispatch(accountLogout());

    apiClient
      .patch(
        `/eai/ems-member-account-user/${emsMemberAccountUserId}/current-account`,
        { emsMemberAccountId: emsMemberAccountId },
        { headers }
      )
      .then((_response: AxiosResponse<any>) => {
        callback && callback();
      })
      .catch((error: AxiosError) => logError(error));
  };

export const createEmsMemberAccountUser =
  (
    requestBody: CreateEmsMemberAccountUserRequestBody,
    callback?: (userId: string) => void
  ): AppThunk =>
  (dispatch: Dispatch<ReturnType<typeof openSnackbar>>) => {
    const headers: HttpHeaders = createHeaderData(true, '*/*');

    apiClient
      .post('/eai/ems-member-account-user', { ...requestBody }, { headers })
      .then((response: AxiosResponse) => {
        dispatch(
          openSnackbar({
            open: true,
            message: i18n.t('module.eai.messages.createEmsMemberAccountUser'),
            variant: 'alert',
            alert: {
              color: 'success'
            },
            close: false
          })
        );
        callback && callback(response.data.userId);
      })
      .catch((error: AxiosError) => logError(error));
  };

export const addUserRoleEmsMemberAccountUser =
  (
    requestBody: AddUserRoleRequestBody,
    emsMemberAccountUserId: string | bigint | undefined,
    callback?: () => any
  ) =>
  (dispatch: Dispatch<ReturnType<typeof openSnackbar>>) => {
    const headers: HttpHeaders = createPutHeaderData(
      true,
      'application/hal+json'
    );
    apiClient
      .put(
        `/eai/ems-member-account-user/${emsMemberAccountUserId}/add-user-role`,
        { ...requestBody },
        { headers }
      )
      .then((_response: AxiosResponse) => {
        //dispatch(getEmsMemberAccountDetail(EmsMemberAccountID));

        dispatch(
          openSnackbar({
            open: true,
            message: i18n.t('module.eai.messages.addUserRole'),
            variant: 'alert',
            alert: {
              color: 'success'
            },
            close: false
          })
        );

        callback && callback();
      })
      .catch((error: AxiosError) => logError(error));
  };

export const deleteUserRoleEmsMemberAccountUser =
  (
    emsMemberAccountUserId: string | bigint | undefined,
    role: string,
    callback?: () => void
  ): AppThunk =>
  (dispatch: Dispatch<ReturnType<typeof openSnackbar>>) => {
    const headers: HttpHeaders = createDeleteHeaderData(true, '*/*');
    const queryParams = createQueryParams({
      roleName: role
    });

    apiClient
      .delete(
        `/eai/ems-member-account-user/${emsMemberAccountUserId}/delete-user-role${queryParams}`,
        { headers }
      )
      .then((_: AxiosResponse) => {
        dispatch(
          openSnackbar({
            open: true,
            message: i18n.t('module.eai.messages.deleteUserRole'),
            variant: 'alert',
            alert: {
              color: 'success'
            },
            close: false
          })
        );

        callback && callback();
      })
      .catch((error: AxiosError) => logError(error));
  };
